import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Models
import { ECardRequest } from '@core/models/club/ecard.model';

/**
 * API e-card — chargement de la carte via une clé publique.
 */
@Injectable({ providedIn: 'root' })
export class ClubECardApi {
	constructor(private http: HttpClient) {}

	baseUrl: string = 'public/json/club/ecard';

	query(key: string) {
		const payload: ECardRequest = { key };

		return this.http.post<any>(`${this.baseUrl}/query`, payload);
	}
}
